import styled from 'styled-components';

export const Motivation = styled.section`

    padding: 3rem 0;

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {


        .motivate {

            width: 55%;
            margin: 0 auto;
            text-align: center;

            h2 {
                font-size: 1.5rem;
                margin-bottom: 1rem;
            }

            p {
                font-weight: 300;
                margin-bottom: 0.5rem;
            }

        }

        @media (max-width: 768px){

            .motivate {

                width: 80%;

            }

        }

        @media (max-width: 500px){

            .motivate {

                width: 100%;

            }

        }

    }

`

export const DonationDetails = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.greyColor };

    .container {

        .donations {

            display: flex;
            justify-content: center;
            align-items: center;

            .donation {

                text-align: center;
                background-color: ${ props => props.theme.lightColor };
                padding: 2rem;

                img {
                    width: 10rem;
                }


                h2 {
                    margin: 1rem 0;
                    color: ${ props => props.theme.primaryColor };
                    font-size: 1.5rem;
                }

                p {
                    font-weight: 300;
                    margin-bottom: 0.5rem;
                }

            }

        }

    }

`